export default {
  'PARTNER' (state) {
    return state.partner
  },
  'PARTNERS' (state) {
    return state.partners
  }
}
